import { Input } from 'antd';
import React from 'react';
import { useFilterContainerClassName, useFilterInputContainerClassName } from '../../../../../utils/languageUtils';
import { useTranslation } from 'react-i18next';
import { getSmartLabelClassName } from '../../../../../utils/labelWidthUtils';
import { PermissionPackageFiltersInput } from '../graphql/queries/getPermissionPackageListing';

export type FilterOptions = {
  id: string;
  name: string;
  description: string;
};

export const DEFAULT_FILTER_OPTIONS: FilterOptions = {
  id: '',
  name: '',
  description: '',
};

export const convertToGraphQLFilters = (options: FilterOptions): PermissionPackageFiltersInput => {
  const filters: PermissionPackageFiltersInput = {};
  const idNum = options.id.trim() ? parseInt(options.id.trim(), 10) : undefined;
  if (idNum !== undefined && !Number.isNaN(idNum)) {
    filters.id = idNum;
  }
  if (options.name.trim()) {
    filters.name = options.name.trim();
  }
  if (options.description.trim()) {
    filters.description = options.description.trim();
  }
  return filters;
};

interface FilterAreaProps {
  filters: FilterOptions;
  setFilters: (options: FilterOptions) => void;
}

const FilterArea: React.FC<FilterAreaProps> = ({ filters, setFilters }) => {
  const { t } = useTranslation();

  const containerClassName = useFilterContainerClassName();
  const inputContainerClassName = useFilterInputContainerClassName();

  const labelId = String(t('central.platformPermission.permissionPackage.filters.id'));
  const labelName = String(t('central.platformPermission.permissionPackage.filters.name'));
  const labelDescription = String(t('central.platformPermission.permissionPackage.filters.description'));
  const colLabels = [labelId, labelName, labelDescription];

  return (
    <div className="mb-2 pl-0 py-2">
      <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
        <div className="min-w-0">
          <div className={containerClassName}>
            <span className={getSmartLabelClassName(colLabels)}>{labelId}</span>
            <div className={inputContainerClassName}>
              <Input
                placeholder={t('components.input.typeIn') as string}
                value={filters.id}
                onChange={(e) => setFilters({ ...filters, id: e.target.value })}
                allowClear
                size="middle"
                className="w-full"
              />
            </div>
          </div>
        </div>
        <div className="min-w-0">
          <div className={containerClassName}>
            <span className={getSmartLabelClassName(colLabels)}>{labelName}</span>
            <div className={inputContainerClassName}>
              <Input
                placeholder={t('components.input.typeIn') as string}
                value={filters.name}
                onChange={(e) => setFilters({ ...filters, name: e.target.value })}
                allowClear
                size="middle"
                className="w-full"
              />
            </div>
          </div>
        </div>
        <div className="min-w-0">
          <div className={containerClassName}>
            <span className={getSmartLabelClassName(colLabels)}>{labelDescription}</span>
            <div className={inputContainerClassName}>
              <Input
                placeholder={t('components.input.typeIn') as string}
                value={filters.description}
                onChange={(e) => setFilters({ ...filters, description: e.target.value })}
                allowClear
                size="middle"
                className="w-full"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterArea;
